module.exports = __webpack_public_path__ + "static/media/mraBlog.c317180f.jpg";